
export default {
    name: 'TablePromotion',
    // 定义组件属性
    props: {
        // 表格数据
        tableData: {
            type: Array,
            default: () => []
        },
        // 表格类型：'reward' | 'friend' | 'group'
        tableType: {
            type: String,
            default: 'reward'
        }
    },
    computed: {
        // 根据表格类型定义不同的列配置
        columnConfig() {
            return this.getColumnConfig()
        },
        // 计算是否有数据
        hasData() {
            return this.tableData && this.tableData.length > 0
        }
    },
    methods: {
        // 根据表格类型定义不同的列配置
        getColumnConfig() {
            switch (this.tableType) {
                case 'reward':
                    return {
                        headers: ['游戏', '订单号', '提成类型', '完成订单时间', '我的奖励'],
                        columns: ['gameName', 'orderNo', 'status', 'orderCompleteTime', 'profitAmount']
                    }
                case 'friend':
                    return {
                        headers: ['组员', '加入时间'],
                        columns: ['nickName', 'createTime']
                    }
                case 'group':
                    return {
                        headers: ['用户', '加入时间'],
                        columns: ['nickname', 'createTime']
                    }
                default:
                    return {
                        headers: ['游戏名称', '包赔费提成', '状态'],
                        columns: ['gameName', 'orderNo', 'status']
                    }
            }
        },
        // 获取列值的方法
        getColumnValue(item, columnIndex) {
            const column = this.columnConfig.columns[columnIndex]
            switch (this.tableType) {
                case 'reward':
                    if (column === 'gameName') return item.gameName || '--'
                    if (column === 'orderNo') return item.orderNo || '--'
                    if (column === 'status') return item.benefitType ? '组长间接奖励' : '绑定直接奖励'
                    if (column === 'orderCompleteTime') return item.orderCompleteTime || '--'
                    if (column === 'profitAmount') return item.profitAmount ? `￥${item.profitAmount}` : '--'
                    return ''
                case 'friend':
                    if (column === 'nickName') return item.nickName || item.inviteeNickName || '--'
                    if (column === 'createTime') return item.createTime || '--'
                    if (column === 'status') return '已注册'
                    return ''
                case 'group':
                    if (column === 'nickname') return item.nickname || item.inviteeNickName || '--'
                    if (column === 'createTime') return item.createTime || '--'
                    if (column === 'status') return '已加入'
                    return ''
                default:
                    return item[column] || ''
            }
        },
        // 获取表头样式类
        getHeaderClass(header, index) {
            const isThreeColumn = this.columnConfig.headers.length === 3

            if (isThreeColumn) {
                // 三列布局
                if (index === 0) return 'col-game'
                if (index === 1) return 'col-rebate'
                if (index === 2) return 'col-status'
            } else {
                // 两列布局，每列50%
                return 'col-half'
            }
            return 'col-game'
        },
        // 获取列样式类
        getColumnClass(columnIndex) {
            const columnCount = this.columnConfig.headers.length

            if (columnCount === 5) {
                // 五列布局（reward类型）
                if (columnIndex === 0) return 'col-game'
                if (columnIndex === 1) return 'col-order'
                if (columnIndex === 2) return 'col-type'
                if (columnIndex === 3) return 'col-time'
                if (columnIndex === 4) return 'col-reward'
            } else if (columnCount === 3) {
                // 三列布局
                if (columnIndex === 0) return 'col-game'
                if (columnIndex === 1) return 'col-rebate'
                if (columnIndex === 2) return 'col-status'
            } else {
                // 两列布局，每列50%
                return 'col-half'
            }
            return 'col-game'
        },
        // 获取状态样式类
        getStatusClass(item) {
            if (this.tableType === 'reward') {
                return 'active'
            }
            return 'active'
        }
    }
}
